{
  "tierProgress": {
    "tierTitle": "Tasokehityksesi",
    "lifetimeTitle": "Lifetime-tasokehityksesi",
    "lifetimeTarget": "Lifetime {tier}",
    "pointsToGo": "{points} tasopistettä jäljellä",
    "reachedLumo": "Saavutettu",
    "tierDescription": "Olet matkalla {tier}-tasolle",
    "lifetimeDescription": "Saa {tier}-tason edut eliniäksi saavuttamalla Lifetime {tier} -tason"
  }
}
